module.exports = __webpack_public_path__ + "img/logo.692d2026.png";